<template>
  <div class="fronts-list">
    <v-banner color="error" dark v-if="fetchAllError">
      <v-icon slot="icon" color="white" size="36">mdi-wifi-strength-alert-outline</v-icon>
      {{ errorDisplay(fetchAllError) }}
      <template v-slot:actions>
        <v-btn text color="dark" @click="fetchAll">Retry</v-btn>
      </template>
    </v-banner>
        <v-banner>
      <v-avatar slot="icon" size="40">
        <v-icon>info</v-icon>
      </v-avatar>
      <div class="title-1">Tips</div>
      <div v-if="displayInfo" class="caption">
        <span>On this page you can display all Front applications. You can add, edit or delete Front applications. Each front has several settings:</span>
        <ul>
          <li><strong>Client ID</strong>: must begin with 'front-' prefix. This is the string that will be used in your front ask for token on behalf on the user.</li>
          <li><strong>Name</strong>: human readable name of front application for documentation purposes.</li>
          <li><strong>Description</strong>: quick overview of Front functionalities.</li>
          <li><strong>Root URL</strong>: fill out with API url of front application, for documentation purposes (https://example.taster.com).</li>
          <li><strong>Redirect URI</strong>: fill out with front application root url, followed by '/*' (https://example.taster.com/*).</li>
          <li><strong>Web origins</strong>: set of different URIs in order to handle oauth2 redirection on front application. Must reference API URL, followed by '/*' (https://example.taster.com/*). You can add multiple web origins, espacially for tests purposes (e.g. http://localhost:8080/*).</li>
        </ul>
      </div>
      <template v-slot:actions>
        <v-btn text color="dark" @click="displayInfo = !displayInfo">{{displayInfo ?'Hide':'Show'}}</v-btn>
      </template>
    </v-banner>
    <v-container>
      <FrontsTable
        v-on:refresh="refresh"
        v-on:createNew="openFrontCreationDialog"
        v-on:editFront="goToFrontDetails"
        v-on:deleteFront="openFrontDeletionDialog"
      />
      <FrontCreationDialog
        :dialog="creationDialog"
        v-on:cancel="creationDialog = false"
        v-on:save="createFront"
        ref="creationDialog"
      />
      <FrontDeletionDialog
        :front="selectedFront"
        :dialog="deletionDialog"
        v-on:cancel="deletionDialog = false"
        v-on:deleteFront="deleteFront"
      />
    </v-container>
    <v-snackbar v-model="snackbar" top>
      {{ errorMessage }}
      <v-btn color="red" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import mixin from "@/mixins";
import FrontsTable from "@/components/Admin/Fronts/FrontsTable";
import FrontCreationDialog from "@/components/Admin/Fronts/FrontCreationDialog";
import FrontDeletionDialog from "@/components/Admin/Fronts/FrontDeletionDialog";

export default {
  name: "FrontsList",
  components: { FrontsTable, FrontCreationDialog, FrontDeletionDialog },
  mixins: [mixin],
  data() {
    return {
      creationDialog: false,
      deletionDialog: false,
      selectedFront: {},
      snackbar: false,
      errorMessage: "",
      displayInfo: false,
    };
  },
  computed: {
    ...mapState({
      fronts: state => state.fronts.all,
      fetchAllLoading: state => state.fronts.fetchAll.pending,
      fetchAllError: state => state.fronts.fetchAll.error
    })
  },
  methods: {
    ...mapActions("fronts", { fetchAll: "fetchAll" }),
    ...mapActions("fronts", { createOne: "createOne" }),
    ...mapActions("fronts", { deleteOne: "deleteOne" }),
    refresh() {
      this.fetchAll();
    },
    openFrontCreationDialog() {
      this.creationDialog = true;
    },
    openFrontDeletionDialog(front) {
      this.selectedFront = front;
      this.deletionDialog = true;
    },
    goToFrontDetails(front) {
      this.$router.push(`/admin/fronts/${front.uuid}`);
    },
    createFront(id, name, description, rootUrl) {
      this.createOne({
        id: id,
        name: name,
        description: description,
        url: rootUrl,
        redirectUris: [],
        webOrigins: []
      })
        .then(() => {
          this.refresh();
          this.creationDialog = false;
          this.$refs.creationDialog.reset();
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    },
    deleteFront(uuid) {
      this.deleteOne({ uuid: uuid })
        .then(() => {
          this.deletionDialog = false;
          this.selectedFront = {};
          this.refresh();
        })
        .catch(error => {
          this.snackbar = true;
          this.errorMessage = this.errorDisplay(error);
        });
    }
  },
  created() {
    this.fetchAll();
  }
};
</script>